module.exports = __webpack_public_path__ + "img/logo-opacity.c23bb486.svg";